<template>
  <ui-dialog
    :show="isOpen"
    persistent
    scrollable
    max-width="697"
    custom-class="facilities-details-edit-labels-dialog"
    @input="close"
  >
    <template #header>
      <h3 class="labels-dialog__heading">
        {{ $t(title) }}
      </h3>
      <p class="labels-dialog__description">
        {{ $t(description) }}
      </p>
    </template>
    <template #default>
      <v-list v-if="editedLabels.length" class="labels-dialog__list">
        <v-list-item
          class="labels-dialog__list-item"
          v-for="(item, index) in editedLabels"
          :key="item.id"
        >
          <v-text-field
            :ref="item.id"
            v-model.trim="editedLabels[index].value"
            clearable
            :counter="maxCharactersCount"
            :maxlength="maxCharactersCount"
            >{{ item }}</v-text-field
          >
          <v-btn
            icon
            color="pink"
            @click="deleteLabel(index)"
            class="ml-3 mb-2"
          >
            <v-icon>
              icon-trash
            </v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
      <div v-else>
        <p class="text-center">
          {{ $t("message.facilityDetails.labels.dialog.noLabels") }}
        </p>
      </div>
      <ui-button
        v-if="editedLabels.length < maxLabelsCount"
        icon="mdi-plus"
        class="mt-2"
        @click="addNewLabel"
      >
        {{ $t("message.facilityDetails.labels.dialog.addLabelBtn") }}
      </ui-button>
    </template>
    <template #actions>
      <div class="labels-dialog__actions">
        <ui-button outlined @click="close">
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button color="primary" @click="save">
          {{ $t(`message.facilityDetails.labels.dialog.applyBtn`) }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import cuid from "cuid";
import { uniq } from "lodash";

export default {
  name: "EditLabelsDialog",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "message.facilityDetails.labels.dialog.title"
    },
    description: {
      type: String,
      default: "message.facilityDetails.labels.dialog.description"
    }
  },
  data() {
    return {
      editedLabels: [],
      maxLabelsCount: 10,
      maxCharactersCount: 50
    };
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.editedLabels = [...this.labels].map(label => {
          return { value: label, id: cuid() };
        });
      } else {
        this.editedLabels = [];
      }
    }
  },
  methods: {
    deleteLabel(index) {
      if (index >= 0) {
        this.editedLabels.splice(index, 1);
      }
    },

    addNewLabel() {
      const id = cuid();
      this.editedLabels.push({ value: "", id });

      setTimeout(() => {
        this.$refs[id][0].focus();
      }, 50);
    },

    close() {
      this.$emit("close");
    },

    save() {
      this.$emit(
        "save",
        uniq([
          ...this.editedLabels
            .filter(label => label.value)
            .map(labelObj => labelObj.value)
        ])
      );
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.labels-dialog {
  &__heading {
    line-height: 36px;
  }

  &__description {
    @include font-size(14px);
    color: $text;
    opacity: 0.4;
    line-height: 20px;
  }

  &__list {
    padding: 0;
  }

  &__list-item {
    display: flex;
    align-items: center;
    padding: 0;
  }

  &__actions {
    margin-top: $spacing * 8;
    width: 100%;
    display: flex;
    justify-content: center;

    & > button:first-child {
      margin-right: $spacing;
    }

    & > button:last-child {
      margin-left: $spacing;
      min-width: 230px !important;
    }
  }
}
</style>

<style lang="scss">
.facilities-details-edit-labels-dialog {
  .v-card__title {
    padding-bottom: 0 !important;
  }
  .v-card__text {
    padding-top: 0 !important;
  }
}
</style>
